import { c as _c } from "react/compiler-runtime";
import { getBlogs } from "@/features/rants/actions/blogs";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import useScrollThreshold from "@/hooks/use-scroll-threshold";
export function useBlogs(tagsArray) {
  const $ = _c(7);
  let t0;
  if ($[0] !== tagsArray) {
    t0 = {
      queryKey: ["blogs", tagsArray],
      queryFn: t1 => {
        const {
          pageParam
        } = t1;
        return getBlogs(tagsArray, pageParam);
      },
      placeholderData: keepPreviousData,
      getNextPageParam: _temp,
      initialPageParam: ""
    };
    $[0] = tagsArray;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const query = useInfiniteQuery(t0);
  useScrollThreshold(query.fetchNextPage, query.hasNextPage, query.isFetchingNextPage);
  let t1;
  if ($[2] !== query.data?.pages) {
    t1 = query.data?.pages.flatMap(_temp2) ?? [];
    $[2] = query.data?.pages;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== query || $[5] !== t1) {
    t2 = {
      ...query,
      blogs: t1
    };
    $[4] = query;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp2(page) {
  return page.blogs;
}
function _temp(lastPage) {
  let nextPage = undefined;
  if (lastPage?.next) {
    nextPage = lastPage.next;
  }
  return nextPage;
}